/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';
import { getTitle } from './helpers/title';
import { OPERATION } from './helpers/constants';
import { getChangeLog } from './helpers/changeLog';

const getDataForDiff = data => JSON.stringify(data || '', null, 2);

function RevisionItem(props) {
  const { revision } = props;
  const { updatedAt } = revision;
  const [showDiff, setShowDiff] = useState(false);
  const oldValue = getDataForDiff(revision.prevDocumentData);
  const newValue = getDataForDiff(revision.documentData);

  return (
    <div className="revision-item">
      <div className="timestamp">{moment(updatedAt).format('lll')}</div>
      <div className="from-now">{moment(updatedAt).fromNow()}</div>
      <div className="content">
        <span className="diff-toggle" onClick={() => setShowDiff(!showDiff)}>
          {showDiff ? 'Hide Details' : 'Show Details'}
        </span>
        {getTitle(revision)}
        {revision.operation === OPERATION.UPDATE && (
          <ul className="changelog">
            {getChangeLog(revision).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )}
        {showDiff && (
          <div className="revision-diff-view">
            <ReactDiffViewer
              oldValue={oldValue}
              newValue={newValue}
              compareMethod={DiffMethod.WORDS}
              leftTitle="Before"
              rightTitle="After"
            />
          </div>
        )}
      </div>
    </div>
  );
}

RevisionItem.propTypes = {
  revision: PropTypes.object,
};

export default RevisionItem;
